import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Image } from '@change-corgi/design-system-legacy/components/media';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading } from '@change-corgi/design-system-legacy/typography';

import { PREVIEW_CHARACTER_LIMIT } from '../../../../../../constants';
import type { PreviewEmailContentBoxProps } from '../../../../types';

import { PreviewEmailContentSubject } from './components/PreviewEmailContentSubject';
import { PreviewEmailContentUpdate } from './components/PreviewEmailContentUpdate';
import { PreviewEmailCtaButtons } from './components/PreviewEmailCtaButtons';

export function PreviewEmailContentBox({ subject, body, imageDataUrl }: PreviewEmailContentBoxProps): JSX.Element {
	return (
		<Box sx={{ backgroundColor: 'neutral-grey50' }} py={16}>
			<Flex sx={{ flexDirection: 'column' }}>
				<Box px={16} mb={16}>
					<Heading
						size="h5"
						as="h3"
						sx={{
							fontFamily: 'Helvetica Neue',
							textTransform: 'uppercase',
							color: 'typography-secondary',
						}}
					>
						<Translate value="corgi.petition_update.preview_modal.content_title" />
					</Heading>
				</Box>
				{imageDataUrl && (
					<Box mb={16} sx={{ overflow: 'hidden' }}>
						<Image sx={{ width: '100%' }} src={imageDataUrl} alt="" />
					</Box>
				)}
				<PreviewEmailContentSubject text={subject} />
				<PreviewEmailContentUpdate contentHtml={body} limit={PREVIEW_CHARACTER_LIMIT} />
				<PreviewEmailCtaButtons />
			</Flex>
		</Box>
	);
}
